import { z } from "zod";

export type IndustryOption = {
  id: number;
  industryName: string;
};

export type TagOption = {
  id: number;
  tag: string;
};

export const accountValidationSchema = z.object({
  dialerType: z.array(z.string()).nullable().optional(),
  noAutoRenew: z.boolean().nullable().optional(),
  contractExpiration: z.date().nullable().optional(),
  termCommitment: z.boolean().nullable().optional(),
  reminderNote: z.string().nullable().optional(),
  reminderDate: z.date().nullable().optional(),
  tags: z.array(z.string()).nullable().optional(),
  industryId: z.number().nullable().optional(),
  industryOptions: z
    .array(
      z.object({
        id: z.number(),
        industryName: z.string(),
      }),
    )
    .optional(),
  tagOptions: z
    .array(
      z.object({
        id: z.number(),
        tag: z.string(),
      }),
    )
    .optional(),
  reminderType: z.string().nullable().optional(),
  reminderFrequency: z.string().nullable().optional(),
});
